module.exports = __webpack_public_path__ + "static/media/logo_text@2x.4e03831e.png";